import {
  componentName,
  ButtonMultiSelectionGroupInternalClass,
} from './ButtonMultiSelectionGroupInternalClass';

customElements.define(componentName, ButtonMultiSelectionGroupInternalClass);

export { ButtonMultiSelectionGroupInternalClass };
